import React from 'react';

interface HomeIconProps {
  className?: string;
}

const HomeIcon: React.FC<HomeIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 1L1 6v9h4v-6h6v6h4V6L8 1z" stroke="currentColor" strokeWidth="1" fill="none" strokeLinejoin="round"/>
  </svg>
);

export default HomeIcon;